import React, { useRef, useEffect, useState } from "react";
import "./button.css";
import {
  DocumentEditorContainerComponent,
  Toolbar,
  WordExport,
  SfdtExport,
  Ribbon,
} from "@syncfusion/ej2-react-documenteditor";
import { syncServiceUrl } from "../utils/Constant";
import { message, Modal, Tooltip } from "antd";
import { useLocation } from "react-router-dom";
import { useTheme } from "../utils/themeToggle/theme";
import { CloseOutlined } from "@ant-design/icons";

DocumentEditorContainerComponent.Inject(Toolbar, WordExport, SfdtExport, Ribbon);

function EditDocComponent({
  fileUrl,
  isEditable,
  userName,
  onClose,
  hasBeenShown,
  setShowEditor
}) {
  const containerRef = useRef(null);
  const [isDirty, setIsDirty] = useState(false);
  const [showLeaveModal, setShowLeaveModal] = useState(false);
  const location = useLocation();
  const pathname = location.pathname;
  const searchParams = new URLSearchParams(location.search);
  // const query = new URLSearchParams(location.search);
  const editableParam = isEditable || searchParams.get("editable") === "true";
  const { darkMode } = useTheme();
  console.log(pathname, "pathname");
  isEditable = editableParam;

  const cretePath =
    pathname.includes("create_request") ||
    (searchParams.has("agreement_id") && pathname.includes("contracts"));

  const toolItem = {
    prefixIcon: "e-save",
    tooltipText: "Save",
    text: "Save",
    id: "Save",
    disabled: hasBeenShown,

  };

  const toolbarItems = isEditable
    ? [
      "Undo",
      "Redo",
      toolItem,
      "Separator",
      "Image",
      "Table",
      "Hyperlink",
      "Bookmark",
      "TableOfContents",
      "Separator",
      "Header",
      "Footer",
      "PageSetup",
      "PageNumber",
      "Break",
      "InsertFootnote",
      "InsertEndnote",
      "Separator",
      "Find",
      "Separator",
      "Comments",
      "TrackChanges",
      "Separator",
      "LocalClipboard",
      "RestrictEditing",
      "Separator",
      "FormFields",
      "UpdateFields",
    ]
    : [];

  // 🟢 Track changes
  useEffect(() => {
    const container = containerRef.current;
    if (!container?.documentEditor) return;

    const handleContentChange = () => {
      setIsDirty(true);
    };

    container.documentEditor.contentChange = handleContentChange;
  }, []);

  const onCreated = () => {
    const container = containerRef.current;
    if (!container || !container.documentEditor) return;

    container.documentEditor.currentUser = userName;
    container.documentEditor.userColor = darkMode ? "#ffffff" : "#000000";

    // Dark/Light theme
    const editorClass = darkMode ? 'dark' : 'light';
    if (container.element) {
      container.element.classList.add(editorClass);
    }

    container.documentEditor.pageColor = darkMode ? "#17153B" : "#FFFFFF";

    if (pathname.includes("version-diff-viewer")) {
      container.documentEditor.isReadOnly = true;
      container.documentEditor.restrictEditing = true;
    } else {
      container.documentEditor.isReadOnly = false;
      container.documentEditor.restrictEditing = false;
    }

    setInterval(() => {
      updateDocumentEditorSize();
    }, 100);

    window.addEventListener("resize", onWindowResize);
  };



  const onWindowResize = () => {
    updateDocumentEditorSize();
  };

  const updateDocumentEditorSize = () => {
    const container = containerRef.current;
    if (container) container.documentEditor.resize();
  };

  // 🔹 Load document
  useEffect(() => {
    const container = containerRef.current;
    if (!fileUrl || !container?.documentEditor) return;

    const uploadDocument = new FormData();
    uploadDocument.append("DocumentName", fileUrl);

    const url = container.serviceUrl + "LoadDocument";
    const httpRequest = new XMLHttpRequest();
    httpRequest.open("POST", url, true);

    httpRequest.onreadystatechange = function () {
      if (httpRequest.readyState === 4 && httpRequest.status === 200) {
        container.documentEditor.open(httpRequest.responseText);
        container.documentEditor.documentName = "Document";
        console.log("✅ Loaded:", fileUrl);
      }
    };

    httpRequest.send(uploadDocument);
  }, [fileUrl]);

  const onSave = async () => {
    const container = containerRef.current;
    if (container && container.documentEditor) {
      const blob = await container.documentEditor.saveAsBlob("Docx");
      return blob;
    } else {
      console.error("Document editor is not available.");
    }
  };

  const handleClose = async () => {
    if (onClose && typeof onClose === "function") {
      const blob = await onSave();
      setIsDirty(false); // ✅ reset dirty flag after saving
      onClose(blob);
    }
  };

  const handleBeforeUnload = (e) => {
    if (isDirty) {
      e.preventDefault();
      e.returnValue = "";
    }
  };

  useEffect(() => {
    const handleBeforeTabClose = (e) => {
      if (isDirty) {
        e.preventDefault();
        e.returnValue = "";
        setShowLeaveModal(true);
        return "";
      }
    };
    window.addEventListener("beforeunload", handleBeforeTabClose);
    return () => window.removeEventListener("beforeunload", handleBeforeTabClose);
  }, [isDirty]);

  const onSelectionChange = () => {
    const container = containerRef.current;
    if (container && container.documentEditor) {
      const selectedText = container.documentEditor.selection.text;
      if (selectedText) {
        navigator.clipboard
          ?.writeText(selectedText)
          .then(() => console.log("Copied:", selectedText))
          .catch((err) => console.error("Copy failed:", err));
      }
    }
  };

  if (hasBeenShown) {
    message.loading("Saving Document...", 0);
  }

  return (
    <div className="control-pane">
      <div className="control-section">
        <div id="documenteditor_titlebar" className="e-de-ctn-title"></div>
        <div
          id="documenteditor_container_body"
          className="e-de-ctn-body"
          style={{
            height: "100vh",
            width: "99.99%",
            overflowX: "hidden",
            backgroundColor: darkMode ? "#17153B" : "#FFFFFF",
          }}
        >
          {isEditable && !cretePath && (

            <button
              className={`fixed top-1 right-[10px] z-[9999] py-[5px] px-[10px] border rounded cursor-pointer ${darkMode
                ? "bg-[#2C2B3C] text-white border-[#44475A]"
                : "bg-[#FFFFFF] text-black border-[#edebe9]"
                }`}
              onClick={handleClose}
            >
              Save Document
            </button>
          )}

          {
            cretePath &&
            <div className="justify-end items-center px-1 absolute top-[17px] right-0 flex z-[9999]">
              <button onClick={() => { setShowEditor(false); }}
              >
                <Tooltip title="Remove Document Editor" placement="right">
                  <CloseOutlined className="text-red-700 hover:text-red-900 text-[1rem] w-[25px] h-[25px] font-extrabold " />
                </Tooltip>
              </button>
              <button
                className={` z-[9999] py-[5px] px-[10px] border rounded cursor-pointer border-[#9d9c9b] bg-[#E1DFDD]`}
                onClick={handleClose}
              >
                Save Document
              </button>
            </div>

          }

          <DocumentEditorContainerComponent
            id="container"
            ref={containerRef}
            height="100%"
            serviceUrl={`${syncServiceUrl}api/documenteditor/`}
            enableToolbar={isEditable}
            created={onCreated}
            currentUser={userName}
            toolbarItems={isEditable ? toolbarItems : []}
            selectionChange={onSelectionChange}
            enableRuler={true}
            showPropertiesPane={false}
            toolbarMode="Ribbon"
            locale="en-US"
          />
        </div>
      </div>

      <Modal
        open={showLeaveModal}
        title="Unsaved Changes"
        onCancel={() => setShowLeaveModal(false)}
        footer={[
          <button
            key="save"
            className="bg-blue-500 text-white px-2 py-1 rounded ml-2"
            onClick={async () => {
              await handleClose();
              setShowLeaveModal(false);
            }}
          >
            Save Changes
          </button>,
          <button
            key="dontsave"
            className="bg-gray-300 px-2 py-1 rounded ml-2"
            onClick={() => {
              setShowLeaveModal(false);
              window.close();
            }}
          >
            Don’t Save
          </button>,
          <button
            key="cancel"
            className="bg-red-500 text-white px-2 py-1 rounded ml-2"
            onClick={() => {
              setShowLeaveModal(false);
            }}
          >
            Cancel
          </button>,
        ]}
      >
        <p className={darkMode ? "text-white" : "text-black"}>
          You have unsaved changes. Do you want to save your changes before
          closing?
        </p>
      </Modal>
    </div>
  );
}

export default EditDocComponent;
